import { message } from 'ant-design-vue';
import { i18n } from '../i18n';
const successTips = {};
successTips.install = (Vue) => {
    Vue.prototype.$successTips = () => {
        message.success(i18n.t('global.success'));
    };
};
export default successTips;
